var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSurge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/outline/surge"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 8126",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M14.971 22.75h-6c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.31 7.75-7.75 7.75zm-6-20c-4.61 0-6.25 1.64-6.25 6.25v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M11.45 18.06c-.24 0-.82-.09-1.16-.96l-1.14-2.88a1.43 1.43 0 00-1.16-.79l-6 .02a.75.75 0 010-1.5l6-.02H8a2.925 2.925 0 012.56 1.74l.91 2.3 2.06-5.22a1.273 1.273 0 011.09-.911 1.254 1.254 0 011.18.78l1.04 1.97a1.477 1.477 0 001.11.67h4.06a.75.75 0 010 1.5h-4.06a2.92 2.92 0 01-2.43-1.47l-.78-1.48-2.1 5.29a1.336 1.336 0 01-1.19.961z"
  })))));
}
export default SvgVuesaxOutlineSurge;